import React from "react";
import Navigation from "./navigation";
import Footer from "./footer";

export default function Base({ children }) {
  return (
    <div className="font-sans text-base text-dark">
      <Navigation />
      {children}
      <Footer />
    </div>
  );
}
